import ParameterResponse from './parameter-response';

export default class RuleResponse {
  id: string;

  name: string;

  parameters: ParameterResponse[];

  constructor(obj: any = {}) {
    this.id = obj.id || '';
    this.name = obj.name || '';
    this.parameters = ParameterResponse.ofList(obj.parameters);
  }

  public static of(obj: any = {}): RuleResponse {
    return new RuleResponse(obj || {});
  }

  public static ofList(obj: any[] = []): RuleResponse[] {
    return obj.map(this.of);
  }
}
